import script from "./DocumentIdType.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentIdType.vue?vue&type=script&setup=true&lang=js"

import "./DocumentIdType.vue?vue&type=style&index=0&id=5c5a8dc5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c5a8dc5"]])

export default __exports__